import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function Approvals() {
  const [list, setList] = useState([]);
  const load = async () => {
    try {
      const { data } = await api.get("/approvals");
      setList(data);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed to load approvals");
    }
  };
  useEffect(() => { load(); }, []);

  const decide = async (id, approved) => {
    try {
      await api.post(`/approvals/${id}/decision`, { approved });
      toast.success(approved ? "Approved" : "Rejected");
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    }
  };

  return (
    <div className="space-y-5 animate-fade-up">
      <header>
        <p className="text-amber text-xs uppercase tracking-[0.18em] font-medium mb-2">HR Approvals</p>
        <h1 className="font-serif text-3xl">Team requests waiting on your nod.</h1>
        <p className="text-light-ink text-sm mt-2">One tap to approve or reject. Booker gets a WhatsApp instantly.</p>
      </header>

      {list.length === 0 ? (
        <div className="tablo-card p-8 text-center text-light-ink" data-testid="approvals-empty">All caught up — no pending requests.</div>
      ) : (
        <div className="space-y-3">
          {list.map((b) => (
            <div key={b.id} className="tablo-card p-5" data-testid={`approval-row-${b.id}`}>
              <div className="flex items-start justify-between">
                <div>
                  <p className="font-serif text-xl">{b.restaurant?.name}</p>
                  <p className="text-xs text-light-ink mt-1">
                    {b.pax} guests · {b.date} {b.time} · ₹{b.deposit_amount_inr} deposit
                  </p>
                  {b.notes && <p className="text-sm text-light-ink mt-2 italic">"{b.notes}"</p>}
                </div>
              </div>
              <div className="flex gap-3 mt-4">
                <Button onClick={() => decide(b.id, true)} className="flex-1 tablo-btn-primary" data-testid={`approve-${b.id}`}>Approve</Button>
                <Button onClick={() => decide(b.id, false)} className="flex-1 tablo-btn-outline" data-testid={`reject-${b.id}`}>Reject</Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
